import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=b6fa3bce&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=b6fa3bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa3bce",
  null
  
)

export default component.exports